import { __decorate } from "tslib";
import Reportable from '../decorators/reportable';
import UICommon from './common';
class UIPreviewCloseupRenderer {
    owner;
    project;
    CONTAINER_TYPE;
    CLOSEUP_CONTAINER;
    showBagetPrice;
    constructor(owner, project, CONTAINER_TYPE = 'closeup', CLOSEUP_CONTAINER = 'calc_closeup', showBagetPrice = true) {
        this.owner = owner;
        this.project = project;
        this.CONTAINER_TYPE = CONTAINER_TYPE;
        this.CLOSEUP_CONTAINER = CLOSEUP_CONTAINER;
        this.showBagetPrice = showBagetPrice;
    }
    render() {
        this.renderContent();
    }
    renderContent() {
        const contentContainer = this.getContainer();
        if (this.showBagetPrice) {
            const bagetPriceBlock = this.getBagetPriceBlockHTML();
            contentContainer.innerHTML = `<div>${bagetPriceBlock}</div>`;
        }
        contentContainer.appendChild(this.getPreviewElementClone());
        const overlayEl = contentContainer.querySelector('.calc-preview-overlay');
        if (overlayEl && overlayEl.parentNode) {
            overlayEl.parentNode.removeChild(overlayEl);
        }
        const backEl = contentContainer.querySelector('.back');
        if (backEl && backEl.parentNode) {
            backEl.parentNode.removeChild(backEl);
        }
        const priceRow = contentContainer.querySelector('.prices-row-bottom');
        if (priceRow && priceRow.parentNode) {
            priceRow.parentNode.removeChild(priceRow);
        }
        const minDim = Math.min(window.innerHeight, window.innerWidth) / 2;
        this.owner.getQuery().findAndUpdateStyle('.calc_preview_in_room', new Map([
            ['height', `${minDim}px`],
            ['width', `${minDim}px`]
        ]), this.CONTAINER_TYPE);
        return false;
    }
    getBagetPriceBlockHTML() {
        const bagetPrice = this.project.getPropertyPrice('baget');
        if (bagetPrice > 0.0) {
            const bagetPriceFormated = UICommon.formatPrice(bagetPrice);
            return `<span class="flying-price-hint">Багет: ${bagetPriceFormated}</span>`;
        }
        return '';
    }
    getContainer() {
        const el = this.owner.getQuery().one(`#${this.CLOSEUP_CONTAINER}`, this.CONTAINER_TYPE);
        if (el) {
            return el;
        }
        throw new Error('No Closeup container element');
    }
    getPreviewElementClone() {
        const previewEl = this.owner.getQuery().one(`.calc-preview`, 'main');
        if (previewEl) {
            return previewEl.cloneNode(true);
        }
        throw new Error('No preview node to clone');
    }
}
__decorate([
    Reportable
], UIPreviewCloseupRenderer.prototype, "render", null);
__decorate([
    Reportable
], UIPreviewCloseupRenderer.prototype, "renderContent", null);
export default UIPreviewCloseupRenderer;
